// require("dotenv").config();
import React from "react";
import { processMetamaskError, saleType } from "../Common";
const { ethers } = require("ethers");

const contractABI =
  require(`../Contracts/${process.env.REACT_APP_CONTRACT_ABI_NAME}`).abi;
const contractAddress = process.env.REACT_APP_CONTRACT_ADDRESS;
const childContractABI =
  require(`../Contracts/${process.env.REACT_APP_CHILD_CONTRACT_ABI_NAME}`).abi;
const childContractAddress = process.env.REACT_APP_CHILD_CONTRACT_ADDRESS;

// const contractABI = require(`../Contracts/SuperCreators.json`).abi;
// const contractAddress = "0x9c8d2f53f6bff84458f1c84fdaa1e4852ca958e3";
// const childContractABI = require(`../Contracts/SuperCreatorsGenZ.json`).abi;
// const childContractAddress = "0xC2Bae2cdef63BcB0bA60Bb02cd67d912f8371c3D";

export function getSmartContract() {
  const { ethereum } = window;
  if (ethereum) {
    const provider = new ethers.providers.Web3Provider(ethereum);
    const signer = provider.getSigner();
    const smartContract = new ethers.Contract(
      contractAddress,
      contractABI,
      signer
    );
    // console.log("functions", smartContract.functions);
    return { provider, signer, smartContract };
  }
}

export function getSmartContractReadFunctions() {
  const { ethereum } = window;
  if (ethereum) {
    const provider = new ethers.providers.Web3Provider(ethereum);
    // const signer = provider.getSigner();
    const smartContract = new ethers.Contract(
      contractAddress,
      contractABI,
      provider
    );
    // console.log("functions", smartContract.functions);
    return { smartContract };
  }
}

export function getChildSmartContract() {
  const { ethereum } = window;
  if (ethereum) {
    const providerChild = new ethers.providers.Web3Provider(ethereum);
    const signerChild = providerChild.getSigner();
    const smartContractChild = new ethers.Contract(
      childContractAddress,
      childContractABI,
      signerChild
    );
    return { providerChild, signerChild, smartContractChild };
  }
}

export const connectWallet = async () => {
  const { ethereum } = window;
  if (ethereum) {
    try {
      // const connectAddresses = await ethereum.request({
      //   method: "eth_requestAccounts", //fetches request acoount
      // });
      // const { provider, signer } = getSmartContract();
      const { providerChild, signerChild } = getChildSmartContract();
      await providerChild.send("eth_requestAccounts", []);
      const connectAddresses = await signerChild.getAddress();
      const balance = await signerChild.getBalance();
      const chainId = await signerChild.getChainId();
      // console.log("Connect Address: ", connectAddresses);
      // console.log("Balance: ", balance);
      let obj = {};
      if (connectAddresses.length > 0) {
        obj = {
          status: true,
          message: "Address Fetch Succesfully",
          // address: connectAddresses[0],
          address: connectAddresses,
          walletBalance: ethers.utils.formatEther(balance),
          chainId: chainId,
        };
      } else {
        obj = {
          status: false,
          message:
            "Address Not Fetch!, Connect to MetaMask by 'Connect to Wallet Button'",
          address: "",
          walletBalance: null,
          chainId: null,
        };
      }
      return obj;
    } catch (error) {
      return {
        status: false,
        address: "",
        walletBalance: null,
        chainId: null,
        message: error.message,
      };
    }
  } else {
    return {
      status: false,
      address: "",
      walletBalance: null,
      chainId: null,
      message: (
        <span>
          <p>
            {" "}
            🦊{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href={`https://metamask.io/download.html`}
            >
              You must install Metamask, a virtual Ethereum wallet, in your
              browser.
            </a>
          </p>
        </span>
      ),
    };
  }
};

export const getcurrentlyConnectWallet = async () => {
  const { ethereum } = window;
  if (ethereum) {
    try {
      // const connectAddresses = await ethereum.request({
      //   method: "eth_accounts", //fetches all acoounts
      // });
      // const { provider, signer } = getSmartContract();
      const { providerChild, signerChild } = getChildSmartContract();
      await providerChild.send("eth_requestAccounts", []);
      const connectAddresses = await signerChild.getAddress();
      const balance = await signerChild.getBalance();
      const chainId = await signerChild.getChainId();
      // console.log("Connect Address: ", connectAddresses);
      // console.log("Balance: ", ethers.utils.formatEther(balance));
      let obj = {};
      if (connectAddresses.length > 0) {
        obj = {
          status: true,
          message: "Address Fetch Succesfully",
          // address: connectAddresses[0],
          address: connectAddresses,
          walletBalance: ethers.utils.formatEther(balance),
          chainId: chainId,
        };
      } else {
        obj = {
          status: false,
          message:
            "Address Not Fetch!, Connect to MetaMask by Clicking 'Connect to Wallet' Button",
          address: "",
          walletBalance: null,
          chainId: null,
        };
      }
      return obj;
    } catch (error) {
      return {
        status: false,
        address: "",
        walletBalance: null,
        chainId: null,
        message: error.message,
      };
    }
  } else {
    return {
      status: false,
      address: "",
      walletBalance: null,
      chainId: null,
      message: (
        <span>
          <p>
            {" "}
            🦊{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href={`https://metamask.io/download.html`}
            >
              You must install Metamask, a virtual Ethereum wallet, in your
              browser.
            </a>
          </p>
        </span>
      ),
    };
  }
};

export const getcurrentlyConnectChain = async () => {
  const { ethereum } = window;
  if (ethereum) {
    try {
      const chainDetails = await ethereum.on("chainChanged", (chainId) => {
        if (chainId.length > 0) {
          console.log("Chain ID Details is: ", chainId);
          window.location.reload();
        } else {
          console.log("Error in Chain ID");
        }
      });
    } catch (error) {
      console.log("Exception in Chain Changed: ", error);
    }
  } else {
    console.log("Error in Chain ID");
  }
};

export const mintNFT = async (noOfTokens, totalEthers, mintSaleType) => {
  let obj = {};
  try {
    const { ethereum } = window;
    if (ethereum) {
      const { smartContract } = getSmartContract();

      // let baseValue = process.env.REACT_APP_ETHERS_VALUE;
      // let totalETH = parseFloat(noOfTokens) * parseFloat(baseValue);
      let totalETH;
      if (mintSaleType === saleType.PRIVATE_SALE) {
        totalETH = 0;
      } else {
        totalETH = totalEthers;
      }
      totalETH = totalETH.toString();
      // console.log("Total: ",totalETH);
      let nftTxn;
      if (mintSaleType === saleType.PRIVATE_SALE) {
        console.log("Private Sale Section");
        nftTxn = await smartContract.PrivateMint(noOfTokens, {
          value: ethers.utils.parseEther(totalETH),
        });
      } else {
        console.log("Standard Sale Section");
        nftTxn = await smartContract.mint(noOfTokens, {
          value: ethers.utils.parseEther(totalETH),
        });
      }

      console.log("Mining... Please Wait");
      await nftTxn.wait();

      console.log(
        `Mined, See Transaction: https://rinkeby.etherscan.io/tx/${nftTxn.hash}`
      );

      obj = {
        status: true,
        message: `Mined, See Transaction: https://rinkeby.etherscan.io/tx/${nftTxn.hash}`,
        fullMessage: `Mined, See Transaction: https://rinkeby.etherscan.io/tx/${nftTxn.hash}`,
        hash: nftTxn.hash,
      };
    } else {
      obj = {
        status: false,
        message: `Not Mined Transaction`,
        fullMessage: `Not Mined Transaction`,
        hash: "",
      };
      console.log(`Not Mined Transaction`);
    }
  } catch (error) {
    obj = processMetamaskError(error);
  }
  return obj;
};

export const mintNFTBaby = async (noOfTokens, totalEthers, merkleHash) => {
  let obj = {};
  try {
    const { ethereum } = window;
    if (ethereum) {
      const { smartContractChild } = getChildSmartContract();

      let nftTxn;
      // console.log("Baby Mint Section", noOfTokens, totalEthers, merkleHash);
      console.log("Baby Mint Section");
      nftTxn = await smartContractChild.mint(noOfTokens, merkleHash, {
        value: ethers.utils.parseEther(totalEthers.toString()),
      });

      console.log("Mining... Please Wait");
      await nftTxn.wait();

      console.log(
        `Mined, See Transaction: https://rinkeby.etherscan.io/tx/${nftTxn.hash}`
      );

      obj = {
        status: true,
        message: `Mined, See Transaction: https://rinkeby.etherscan.io/tx/${nftTxn.hash}`,
        fullMessage: `Mined, See Transaction: https://rinkeby.etherscan.io/tx/${nftTxn.hash}`,
        hash: nftTxn.hash,
      };
    } else {
      obj = {
        status: false,
        message: `Not Mined Transaction`,
        fullMessage: `Not Mined Transaction`,
        hash: "",
      };
      console.log(`Not Mined Transaction`);
    }
  } catch (error) {
    obj = processMetamaskError(error);
  }
  return obj;
};

export const mintNFTSuperBaby = async (
  noOfTokens,
  totalEthers,
  tokensArray,
  merkleHash
) => {
  // console.log(noOfTokens, totalEthers, tokensArray, merkleHash);
  let obj = {};
  try {
    const { ethereum } = window;
    if (ethereum) {
      const { smartContractChild } = getChildSmartContract();

      let nftTxn;
      // console.log("Baby Mint Section", noOfTokens, totalEthers, merkleHash);
      console.log("Super Baby Mint Section");
      nftTxn = await smartContractChild.superBabiesMint(
        tokensArray,
        merkleHash,
        {
          value: ethers.utils.parseEther(totalEthers.toString()),
        }
      );

      console.log("Mining... Please Wait");
      await nftTxn.wait();

      console.log(
        `Mined, See Transaction: https://rinkeby.etherscan.io/tx/${nftTxn.hash}`
      );

      obj = {
        status: true,
        message: `Mined, See Transaction: https://rinkeby.etherscan.io/tx/${nftTxn.hash}`,
        fullMessage: `Mined, See Transaction: https://rinkeby.etherscan.io/tx/${nftTxn.hash}`,
        hash: nftTxn.hash,
      };
    } else {
      obj = {
        status: false,
        message: `Not Mined Transaction`,
        fullMessage: `Not Mined Transaction`,
        hash: "",
      };
      console.log(`Not Mined Transaction`);
    }
  } catch (error) {
    obj = processMetamaskError(error);
  }
  return obj;
};

export const totalValues = async () => {
  try {
    const { ethereum } = window;
    let total = {
      maxMints: 0,
      totalRemaining: 0,
      maxPerMint: 0,
      price: null,
    };
    let status = true;
    if (ethereum) {
      const { smartContract } = getSmartContract();
      // console.log("functions", smartContract.functions);
      let maxMints = await smartContract.maxGenCount();
      let totalRemaining = await smartContract.totalSupply();
      let maxPerMint = await smartContract.maxMintTokens();
      let price = await smartContract.Price();
      total.maxMints = parseInt(maxMints._hex, 16);
      total.totalRemaining = parseInt(totalRemaining._hex, 16);
      total.maxPerMint = parseInt(maxPerMint._hex, 16);
      total.price = ethers.utils.formatEther(price);
    } else {
      console.log(`Not Mined Transaction`);
      status = false;
    }
    return { status, total };
  } catch (error) {
    return {
      ...processMetamaskError(error),
      total: {},
      error: processMetamaskError(error)?.message,
    };
  }
};

export const isWhitelisted = async (address) => {
  try {
    const { ethereum } = window;
    if (ethereum) {
      const { smartContract } = getSmartContract();

      //console.log('functions',await smartContract.functions);
      let whitelisted = await smartContract.whitelisted(address);
      return { status: true, whitelisted };
    } else {
      console.log(`Not Found Whitelisted Users`);
    }
    return null;
  } catch (error) {
    return {
      ...processMetamaskError(error),
      error: processMetamaskError(error)?.message,
    };
  }
};

export const getBalanceOf = async (address) => {
  try {
    const { ethereum } = window;

    if (ethereum) {
      const { smartContract } = getSmartContract();

      //console.log('functions',await smartContract.functions);
      let balanceOf = await smartContract.balanceOf(address);
      let formattedBalance = balanceOf.toNumber();
      return { status: true, balance: formattedBalance };
    } else {
      console.log(`Not Found Balance`);
    }
    return null;
  } catch (error) {
    return {
      ...processMetamaskError(error),
      error: processMetamaskError(error)?.message,
    };
  }
};

export const getBaseURI = async () => {
  try {
    const { ethereum } = window;
    if (ethereum) {
      const { smartContract } = getSmartContractReadFunctions();
      let baseURI = await smartContract.baseURI();
      return {
        status: true,
        baseURI,
      };
    } else {
      console.log(`Cannot get Base URI`);
    }
    return null;
  } catch (error) {
    console.error(error);
    return {
      ...processMetamaskError(error),
      error: processMetamaskError(error)?.message,
    };
  }
};

export const getWalletOfOwner = async (address) => {
  try {
    const { ethereum } = window;
    if (ethereum) {
      const { smartContract } = getSmartContractReadFunctions();

      //console.log('functions',await smartContract.functions);
      let walletOfOwner = await smartContract.walletOfOwner(address);
      // console.log("Length of Wallet: ", walletOfOwner.length);
      let walletOfOwnerArray = [];
      for (let i = 0; i < walletOfOwner.length; i++) {
        walletOfOwnerArray.push(walletOfOwner[i].toNumber());
      }
      return { status: true, wallet: walletOfOwnerArray };
    } else {
      console.log(`Not Found Owner of Wallet`);
    }
    return null;
  } catch (error) {
    return {
      ...processMetamaskError(error),
      error: processMetamaskError(error)?.message,
    };
  }
};

export const getWalletOfOwnerBaby = async (address) => {
  try {
    const { ethereum } = window;
    if (ethereum) {
      const { smartContractChild } = getChildSmartContract();

      // console.log('functions',await smartContractChild.functions);
      let walletOfOwner = await smartContractChild.walletOfOwner(address);
      // console.log("Length of Wallet: ", walletOfOwner.length);
      let walletOfOwnerArray = [];
      for (let i = 0; i < walletOfOwner.length; i++) {
        walletOfOwnerArray.push(walletOfOwner[i].toNumber());
      }
      return { status: true, wallet: walletOfOwnerArray };
    } else {
      console.log(`Not Found Owner of Wallet`);
    }
    return null;
  } catch (error) {
    return {
      ...processMetamaskError(error),
      error: processMetamaskError(error)?.message,
    };
  }
};

export const getTokenURI = async (tokenId) => {
  try {
    const { ethereum } = window;
    if (ethereum) {
      const { smartContract } = getSmartContractReadFunctions();
      let tokenURI = await smartContract.tokenURI(tokenId);
      return {
        status: true,
        tokenURI,
      };
    } else {
      console.log(`Cannot get Token URI`);
    }
    return null;
  } catch (error) {
    return {
      ...processMetamaskError(error),
      error: processMetamaskError(error)?.message,
    };
  }
};

export const getTokenURIBaby = async (tokenId) => {
  try {
    const { ethereum } = window;
    if (ethereum) {
      const { smartContractChild } = getChildSmartContract();
      let tokenURI = await smartContractChild.tokenURI(tokenId);
      return {
        status: true,
        tokenURI,
      };
    } else {
      console.log(`Cannot get Token URI`);
    }
    return null;
  } catch (error) {
    return {
      ...processMetamaskError(error),
      error: processMetamaskError(error)?.message,
    };
  }
};

export const publicSaleStatus = async () => {
  try {
    const { ethereum } = window;
    if (ethereum) {
      const { smartContract } = getSmartContract();

      //console.log('functions',await smartContract.functions);
      let publicSale = await smartContract.publicSale();
      return { status: true, publicSale };
    } else {
      console.log(`Not Found Public Sale Status`);
    }
    return null;
  } catch (error) {
    return {
      ...processMetamaskError(error),
      error: processMetamaskError(error)?.message,
    };
  }
};

export const publicSaleStatusBaby = async () => {
  try {
    const { ethereum } = window;
    if (ethereum) {
      const { smartContractChild } = getChildSmartContract();

      //console.log('functions',await smartContract.functions);
      let publicSale = await smartContractChild.publicSale();
      return { status: true, publicSale };
    } else {
      console.log(`Not Found Public Sale Status`);
    }
    return null;
  } catch (error) {
    return {
      ...processMetamaskError(error),
      error: processMetamaskError(error)?.message,
    };
  }
};

export const changePublicSaleStatus = async (value) => {
  try {
    const { ethereum } = window;
    if (ethereum) {
      const { smartContract } = getSmartContract();

      //console.log('functions',await smartContract.functions);
      let publicSaleStarted = await smartContract.publicSaleStarted(value);
      return { status: true, publicSaleStarted };
    } else {
      console.log(`Public Sale Status Not Changed`);
    }
    return null;
  } catch (error) {
    return {
      ...processMetamaskError(error),
      error: processMetamaskError(error)?.message,
    };
  }
};

export const privateSaleStatus = async () => {
  try {
    const { ethereum } = window;
    if (ethereum) {
      const { smartContract } = getSmartContract();

      //console.log('functions',await smartContract.functions);
      let privateSale = await smartContract.privateSale();
      return { status: true, privateSale };
    } else {
      console.log(`Not Found Private Sale Status`);
    }
    return null;
  } catch (error) {
    return processMetamaskError(error);
  }
};

export const changePrivateSaleStatus = async (value) => {
  try {
    const { ethereum } = window;
    if (ethereum) {
      const { smartContract } = getSmartContract();

      //console.log('functions',await smartContract.functions);
      let privateSaleStarted = await smartContract.privateSaleStarted(value);
      return { status: true, privateSaleStarted };
    } else {
      console.log(`Private Sale Status Not Changed`);
    }
    return null;
  } catch (error) {
    return processMetamaskError(error);
  }
};

export const getBabyTotalValues = async () => {
  try {
    const { ethereum } = window;
    if (ethereum) {
      const { smartContractChild } = getChildSmartContract();
      let totalSupply = await smartContractChild.totalSupply();
      let maxGenCount = await smartContractChild.maxGenCount();
      let maxPerMintToken = await smartContractChild.maxMintTokens();
      return {
        status: true,
        totalSupply: parseInt(totalSupply._hex, 16),
        maxGenCount: parseInt(maxGenCount._hex, 16),
        maxPerMintToken: parseInt(maxPerMintToken._hex, 16),
      };
    } else {
      console.log(`Cannot get Total Supply`);
      return {
        status: false,
        totalSupply: null,
        maxGenCount: null,
        maxPerMintToken: null,
      };
    }
  } catch (error) {
    return processMetamaskError(error);
  }
};

export const getRequiredTokenForSuperBabies = async () => {
  try {
    const { ethereum } = window;
    if (ethereum) {
      const { smartContractChild } = getChildSmartContract();

      //console.log('functions',await smartContract.functions);
      let requireTokens = await smartContractChild.requireTokenForSuperBabies();

      // console.log("Length of Wallet: ", walletOfOwner.length);
      // console.log("requireTokens",requireTokens)
      return {
        status: true,
        requireTokens: parseInt(requireTokens._hex, 16),
      };
    } else {
      console.log(`Not Found Required Tokens`);
      return {
        status: false,
        requireTokens: null,
      };
    }
  } catch (error) {
    return processMetamaskError(error);
  }
};

export const getBabyBalanceOf = async (address) => {
  try {
    const { ethereum } = window;

    if (ethereum) {
      const { smartContractChild } = getChildSmartContract();

      //console.log('functions',await smartContract.functions);
      let balanceOf = await smartContractChild.balanceOf(address);
      let formattedBalance = balanceOf.toNumber();
      return { status: true, balance: formattedBalance };
    } else {
      console.log(`Not Found Balance`);
    }
    return null;
  } catch (error) {
    return {
      ...processMetamaskError(error),
      error: processMetamaskError(error)?.message,
    };
  }
};
